import * as React from 'react';

import { useSelector, useDispatch } from 'react-redux';
import { useRouter } from 'next/router';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import translateMsg from '~/src/lib/translateMsg';
import { setCookie } from 'nookies';
import actionsLang from '~/redux/lang/actions';
import CloseIcon from '@mui/icons-material/Close';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import isIterable from '~/src/lib/isIterable';
import config from '~/src/config';

export default function App(props) {
    const business = useSelector((state) => state.business);
    const lang = useSelector((state) => state.lang);

    const langUniversal = useSelector((state) => state.langUniversal);

    const [ready, setReady] = React.useState(false);

    const router = useRouter();

    const dispatch = useDispatch();

    React.useEffect(() => {
        if (
            business &&
            isIterable(business.languages2) &&
            Object.keys(langUniversal).length > 0
        ) {
            // liste des langages du business
            const businessLanguages = business.languages2.filter(
                (bl) => bl.display === 1,
            );

            // liste des langages du browser
            const browserLanguages = [];
            navigator.languages.map((bl) => {
                const t = bl.substring(0, 2, bl);
                if (browserLanguages.includes(t) === false) {
                    browserLanguages.push(t);
                }
            });

            //alert(JSON.stringify(browserLanguages));
            //const browserLanguages = ['fr'];

            // langue par defaut du business
            const defaultLanguage = businessLanguages.find(
                (bl) => bl.is_default === 1,
            );

            const commonLanguages = [];

            // on calcule les langages commun
            businessLanguages.map((bl) => {
                if (browserLanguages.includes(bl.iso2)) {
                    commonLanguages.push(bl.iso2);
                }
            });

            //console.log('DEBUG');
            //console.log(lang);
            //console.log(businessLanguages);
            //console.log(browserLanguages);
            //console.log(defaultLanguage);

            // si la langue settée est inclus dans commonLanguages
            // on ne fait rien
            if (commonLanguages.includes(lang) === false) {
                // si la langue settée n'est pas inclus dans businessLanguages
                // on calcule les langues a afficher dans le modal
                const languagesToDisplay = [];
                businessLanguages.map((bl) => {
                    languagesToDisplay.push(bl);
                });

                //console.log(languagesToDisplay);

                const chooseLanguage = localStorage.getItem('chooseLanguage');
                //console.log(chooseLanguage);
                //console.log(typeof chooseLanguage);

                if (!chooseLanguage) {
                    if (
                        browserLanguages.length > 0 &&
                        businessLanguages.length > 0
                    ) {
                        // si la lang setté corresponds a la langue par defaut du business on ne fait rien
                        if (
                            typeof defaultLanguage === 'string' &&
                            lang === defaultLanguage.iso2
                        ) {
                            //return false;
                        } else {
                            setLanguages(languagesToDisplay);
                            setOpen(true);
                        }
                    }
                }
            }
            setReady(true);
        }
    }, [business, langUniversal]);

    const [open, setOpen] = React.useState(false);
    const [languages, setLanguages] = React.useState([]);

    const handleClose = () => {
        localStorage.setItem('chooseLanguage', 'on');
        setOpen(false);
    };

    const handleListItemClick = (l) => {
        handleClose();
        dispatch(actionsLang.setLang(l));
        setCookie(null, 'lang', l, {
            maxAge: 30 * 24 * 600 * 600,
            path: '/',
        });

        setCookie(null, 'NEXT_LOCALE', l, {
            maxAge: 30 * 24 * 600 * 600,
            path: '/',
        });

        setTimeout(() => {
            //location.reload();
            document.location.href = `/${l}/${router.asPath}`;
        }, 300);
    };

    if (!open) {
        return false;
    }

    if (!ready) {
        return false;
    }

    if (!languages) {
        return false;
    }

    if (languages.length < 2) {
        return false;
    }

    return (
        <Dialog onClose={handleClose} open>
            <DialogTitle>
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                    }}
                >
                    <div>
                        {translateMsg(
                            'webapp',
                            'pwa_ui_site_language_selection_question',
                        )}
                    </div>
                    <div onClick={handleClose} style={{ cursor: 'pointer' }}>
                        <CloseIcon />
                    </div>
                </div>
            </DialogTitle>
            {/*
            <ListItem disableGutters>
                <ListItemButton autoFocus onClick={handleClose}>
                    <ListItemText primary={<CloseIcon />} />
                </ListItemButton>
            </ListItem>
                        */}
            <List sx={{ pt: 0 }}>
                {languages.map((language) => {
                    let text = translateMsg(
                        'universal',
                        `uni_lang_${language.iso3}`,
                    );

                    if (
                        typeof config.originalCountryName[language.iso3] ===
                        'string'
                    ) {
                        text = config.originalCountryName[language.iso3];
                    }

                    return (
                        <ListItem disableGutters key={language.iso2}>
                            <ListItemButton
                                onClick={() =>
                                    handleListItemClick(language.iso2)
                                }
                            >
                                <ListItemText primary={text} />

                                {lang === language.iso2 && <CheckCircleIcon />}
                            </ListItemButton>
                        </ListItem>
                    );
                })}
            </List>
        </Dialog>
    );
}
